import React from 'react';
import styles from './styles.module.scss';

/** @import {PasswordRequirement} from '../passwordRequirements' */

/**
 * @typedef {object} PasswordRequirementProps
 * @property {string} password - The password to validate against the requirements.
 * @property {Array<PasswordRequirement>} requirements - An array of password requirements, each with a short description and a validation function.
 */

/**
 * Displays Password requirements based on the password provided
 * @param {PasswordRequirementProps} props
 */
export function PasswordRequirements(props) {
  const { requirements, password } = props;
  const checkSvg = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <mask id="check-cutout">
          <rect width="100%" height="100%" fill="white" />
          <path
            d="M6 12L10 16L18 8"
            fill="none"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
      </defs>
      <circle cx="12" cy="12" r="10" fill="black" mask="url(#check-cutout)" />
    </svg>
  );

  const uncheckedSvg = (
    <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="none" stroke="black" strokeWidth="2" />
    </svg>
  );

  return (
    <ul className={styles.list}>
      {requirements.map((r) => {
        const isValid = r.validator(password) === undefined;

        return (
          <li key={r.shortDescription} className={isValid ? 'satisfied' : 'unsatisfied'}>
            {isValid ? checkSvg : uncheckedSvg}
            <span className={styles.description}>{r.shortDescription}</span>
          </li>
        );
      })}
    </ul>
  );
}
